<template>
  <div class="yaliceshi-jieguo-page">

    <!-- 科技感加载动画 -->
    <AiLoading :visible="loading" title="压力测试完成，下一步生成投资报告"></AiLoading>

    <div class="header">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/yali.png" alt="logo">
        </div>
        <h1>压力测试</h1>
      </div>
      <p class="subtitle">模拟历史危机，检验组合生存线</p>

      <div class="status-banner" :class="{ 'pass': isPass, 'fail': !isPass }">
        <template v-if="isPass">
          <i class="el-icon-check"></i>
          <span>通过：策略净值未击穿风险承受底线，风险可控！</span>
        </template>
        <template v-else>
          <i class="el-icon-warning"></i>
          <span>警告：策略净值已击穿您的风险承受底线！</span>
        </template>
      </div>
    </div>

    <div class="metrics-bar">
      <div class="metric-item" :class="{ 'pass': isPass, 'fail': !isPass }">
        <img v-if="isPass" src="@/assets/yaliceshi/jine0.png">
        <img v-else src="@/assets/yaliceshi/jine1.png">
        <span class="metric-label">总亏损金额</span>
        <span class="metric-value">{{ resultObj.metrics.totalLoss }}</span>
      </div>
      <div class="metric-item" :class="{ 'pass': isPass, 'fail': !isPass }">
        <img src="@/assets/yaliceshi/liudong.png">
        <span class="metric-label">总亏损比例</span>
        <span class="metric-value">{{ resultObj.metrics.totalLossPercentage }}</span>
      </div>
      <div class="metric-item" :class="{ 'pass': isPass, 'fail': !isPass }">
        <img v-if="isPass" src="@/assets/yaliceshi/tongguo.png">
        <img v-else src="@/assets/yaliceshi/weitongguo.png">
        <span class="metric-label">冲击期间最大回撤</span>
        <span class="metric-value">{{ resultObj.metrics.maxDrawdownDuringShock }}</span>
      </div>
      <div class="metric-item">
        <img src="@/assets/yaliceshi/time.png">
        <span class="metric-label">恢复天数</span>
        <span class="metric-value">
          {{ resultObj.metrics.daysToRecover == 0 ? '暂无数据' : resultObj.metrics.daysToRecover + '天' }}</span>
      </div>
    </div>

    <div class="content">
      <div class="left-section">
        <div class="report-card" :class="{ 'pass': isPass, 'fail': !isPass }">
          <h3 class="report-title">
            <i class="el-icon-robot"></i>
            AI风控官·体检报告
          </h3>

          <div class="report-content">
            <div class="test-result">
              <span class="result-label">测试结果：</span>
              <span class="result-value" :class="{ 'pass': isPass, 'fail': !isPass }">{{ isPass ? '通过' : '不通过' }}</span>
            </div>

            <div class="test-details">
              <el-table :data="resultObj.customerEvaluation.dimensions" style="width: 100%" border stripe size="mini">
                <el-table-column prop="displayName" label="指标" width="100" />
                <el-table-column prop="target" label="目标值" width="70" />
                <el-table-column prop="actual" label="实际值" width="70" />
                <el-table-column prop="passed" label="是否完成" width="90">
                  <template slot-scope="scope">
                    {{ scope.row.passed ? '已完成' : '未完成' }}
                  </template>
                </el-table-column>
                <el-table-column prop="gap" label="差值" width="60" />
                <el-table-column prop="insight" label="解析" />
              </el-table>
            </div>

            <div class="suggestions" :class="{ 'pass': isPass, 'fail': !isPass }">
              <h4 class="suggestion-title">{{ isPass ? '配置建议' : '改进建议' }}</h4>
              <template
                        v-if="resultObj.customerEvaluation.suggestions && resultObj.customerEvaluation.suggestions.length > 0">
                <p class="suggestion-content" v-for="(item, index) in resultObj.customerEvaluation.suggestions"
                   :key="index">
                  {{ item }}</p>
              </template>
              <p v-else class="suggestion-content empty">无{{ isPass ? '配置建议' : '改进建议' }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="right-section">
        <div class="chart-card">
          <h3 class="chart-title">冲击期间组合价值曲线</h3>
          <div ref="netValueChart" class="chart"></div>
          <div class="chart-note">
            <!-- <span class="note-item">
              <i class="dot"></i>
              深水区：M3-M5
            </span> -->
            <!-- <span class="data-source">数据来源：2016-2026 历史行情回溯</span> -->
            <span class="data-source">数据来源：历史行情回溯</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="reset-btn common-btn" id="btn-reset-weight" @click="handleReset">
        重新调整权重
      </button>
      <!-- <button class="action-btn common-btn" :class="{ 'pass': isPass, 'fail': !isPass }" @click="handleAction">
        {{ isPass ? '生成投资报告' : '生成风控报告' }} <i class="el-icon-right"></i>
      </button> -->
      <button class="action-btn common-btn" id="btn-generate-report" @click="handleAction">
        {{ isPass ? '生成投资报告' : '生成投资报告' }} <i class="el-icon-right"></i>
      </button>
    </div>
    <div class="footer-bottom">
      <span @click="handleScenario">重新选择测试场景</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
axios.defaults.timeout = 300000
axios.defaults.withCredentials = false
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

import * as echarts from 'echarts'
import AiLoading from '@/components/AiLoading.vue'
export default {
  name: 'YaliceshiJieguoPage',
  components: {
    AiLoading
  },
  data () {
    return {
      // 加载状态
      loading: false,
      // 测试结果状态，true为通过，false为不通过
      isPass: false,
      // 图表数据
      chartData: {
        months: [],
        portfolioValue: [],
        periodReturn: [],
        // months: ['M0', 'M1', 'M2', 'M3', 'M4', 'M5', 'M6', 'M8', 'M12', 'M18'],
        // netValue: [1.0, 0.95, 0.9, 0.8, 0.7, 0.68, 0.75, 0.85, 0.95, 1.0],
        // riskLine: [0.85, 0.85, 0.85, 0.85, 0.85, 0.85, 0.85, 0.85, 0.85, 0.85]
      },
      resultObj: {
        customerEvaluation: {},
        impactByAssetType: [],
        metrics: {},
        scenario: {},
        shockPeriodCurve: []
      },
      FastGptApiUrl: window.FastGptApiUrl,
      FastGptToken_TZBG: window.FastGptToken_TZBG,
      progress: 0,
      interval: null
    }
  },
  watch: {
    loading (val) {
      localStorage.setItem('yaliceshi_jieguo_loading', JSON.stringify({ loading: val }))
    }
  },
  mounted () {
    // 强制重置 loading，防止上一轮异常残留导致卡死
    this.loading = false
    localStorage.removeItem('yaliceshi_jieguo_loading')
    window.addEventListener('storage', this.handleStorageChange)
    // 从localStorage获取压力测试结果
    let result = JSON.parse(localStorage.getItem('yaliceshiResult'))
    if (result) {
      this.resultObj = result
      this.isPass = result.customerEvaluation.meetsExpectation

      let chartData = result.shockPeriodCurve
      chartData.forEach(item => {
        this.chartData.months.push(item.tradingDate)
        this.chartData.portfolioValue.push(item.portfolioValue)
        this.chartData.periodReturn.push(item.periodReturn * 100)
      })
    }
    this.initChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy () {
    this.loading = false
    localStorage.removeItem('yaliceshi_jieguo_loading')
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('resize', this.resizeChart)
    if (this.netValueChart) {
      this.netValueChart.dispose()
    }
  },
  methods: {
    handleStorageChange (event) {
      if (event.key === 'yaliceshi_jieguo_loading' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue)
          this.loading = data.loading
        } catch (e) { /* ignore */ }
      }
    },
    // 播放音频
    runAudio () {
      this.playOnceAudio('/压力测试完成，下一步生成投资报告预计1分钟请稍等~.mp3')
    },
    initChart () {
      this.netValueChart = echarts.init(this.$refs.netValueChart)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['当日组合价值', '当日收益率'],
          top: 0
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          name: '时间轴',
          nameLocation: 'middle',   // 可选值：'start', 'middle', 'end'
          nameGap: 25,  // 名称与X轴线的距离（像素）
          type: 'category',
          boundaryGap: false,
          data: this.chartData.months
        },
        yAxis: [
          {
            type: 'value',
            name: '组合价值',
            axisLabel: {
              formatter: '¥{value}'
            }
          },
          {
            type: 'value',
            name: '收益率',
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: [
          {
            name: '当日组合价值',
            type: 'line',
            yAxisIndex: 0,
            data: this.chartData.portfolioValue,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#ef4444',
              width: 2
            },
            itemStyle: {
              color: '#ef4444'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(239, 68, 68, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(239, 68, 68, 0.1)'
                }
              ])
            }
          },
          {
            name: '当日收益率',
            type: 'line',
            yAxisIndex: 1,
            data: this.chartData.periodReturn,
            // symbol: 'none',
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#5070dd',
              width: 1,
              type: 'dashed'
            },
            itemStyle: {
              color: '#5070dd'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(80, 112, 221, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(80, 112, 221, 0.1)'
                }
              ])
            }
          }
        ]
      }

      this.netValueChart.setOption(option)
    },
    resizeChart () {
      if (this.netValueChart) {
        this.netValueChart.resize()
      }
    },
    handleReset () {
      // 重新调权配置的逻辑
      console.log('重新调权配置')
      this.$router.push({ name: 'Tiaozhengzichanbili' })
    },
    handleAction () {
      // 生成报告的逻辑
      console.log(this.isPass ? '生成投资报告' : '生成风控报告')
      this.useFastgptapi()
    },
    handleScenario () {
      // 重新选择测试场景的逻辑
      console.log('重新选择测试场景')
      this.$router.push({ name: 'Yaliceshi' })
    },
    // 资产类型名称转换
    typenName (type) {
      switch (type) {
        case 'C1':
          return '保守型'
        case 'C2':
          return '稳健型'
        case 'C3':
          return '平衡型'
        case 'C4':
          return '成长型'
        case 'C5':
          return '进取型'
      }
    },
    // 模型名称转换
    modelName (name) {
      switch (name) {
        case 'MeanVariance':
          return '经典 Markowitz 均值-方差模型'
        case 'RiskParity':
          return 'RiskParity 风险平价模型'
        case 'MinVariance':
          return 'MinVariance 最小方差模型'
        case 'BlackLitterman':
          return 'Black-Litterman 贝叶斯均值方差模型'
        case 'EqualWeight':
          return 'EqualWeight 等权 1/N模型'
      }
    },
    // 格式化百分比
    formatPercent (value) {
      return `${(value * 100).toFixed(2)}%`;
    },
    // 格式化金额
    formatMoney (value) {
      return `${Math.round(value).toLocaleString("zh-CN")}元`;
    },
    // 计算未来收益率
    calculateFutureReturns ({ annualizedReturn, annualizedVolatility, investmentHorizonYears, principal = 1000000 }) {
      const scenarios = {
        pessimistic: annualizedReturn - annualizedVolatility,
        neutral: annualizedReturn,
        optimistic: annualizedReturn + annualizedVolatility
      };

      const result = {};

      Object.entries(scenarios).forEach(([key, annualRate]) => {
        let cumulativeRate;

        if (1 + annualRate < 0) {
          cumulativeRate = -1;
        } else {
          cumulativeRate = Math.pow(1 + annualRate, investmentHorizonYears) - 1;
        }

        const finalValue = Math.max(0, principal * (1 + cumulativeRate));

        result[key] = {
          annual: this.formatPercent(annualRate),
          cumulative: this.formatPercent(cumulativeRate),
          finalValue: this.formatMoney(finalValue)
        };
      });

      return result;
    },
    // 安全读取 localStorage 中的 JSON 数据，缺失或解析失败时返回默认值
    readStorageJSON (key, fallback = null) {
      try {
        const raw = localStorage.getItem(key)
        if (raw === null || raw === '') return fallback
        return JSON.parse(raw)
      } catch (e) {
        console.error(`[报告生成] 读取 ${key} 失败`, e)
        return fallback
      }
    },
    useFastgptapi () {
      // 调用FASTGPT API生成投研报告
      console.log('调用FASTGPT API生成投研报告')
      // 这里可以添加实际的API调用逻辑
      this.loading = true
      this.runAudio()
      //kyc拼接
      const riskResult = this.readStorageJSON('riskResult', null)
      if (!riskResult || !riskResult.customerProfile) {
        this.loading = false
        this.$message.warning('未获取到客户风险画像，请重新完成风险评估')
        return
      }
      let kyc = {
        "type": riskResult.type,
        "typeName": this.typenName(riskResult.type),
        "customerProfile": riskResult.customerProfile
      }
      console.log("客户风险画像kyc>>>>", kyc);
      // model拼接
      const modelName = localStorage.getItem('modelName') || ''
      const modelWeights = this.readStorageJSON('modelWeights', {})
      let model = {
        "name": modelName,
        "displayName": this.modelName(modelName),
        "weights": modelWeights
      }
      console.log("模型权重model>>>>", model);
      //portfolio拼接
      const NewrecommendResult = this.readStorageJSON('NewrecommendResult', {})
      const recommendProducts = Array.isArray(NewrecommendResult.products) ? NewrecommendResult.products : []
      let portfolio = {
        "topHoldings": recommendProducts.map(product => ({
          "code": product.code,
          "name": product.name || product.code || '',
          "category": product.productType || '',
          "weight": product.weight
        }))
      }
      console.log("组合权重portfolio>>>>", portfolio);
      //backtest 拼接
      const backtestParams = this.readStorageJSON('backtestParams', {})
      const backtestResult = this.readStorageJSON('backtestResult', {})
      const backtestMetrics = backtestResult.metrics || {}
      const backtestProfile = backtestParams.customerProfile || {}
      const backtestEvaluation = backtestResult.customerEvaluation || {}
      const backtestDimensions = Array.isArray(backtestEvaluation.dimensions) ? backtestEvaluation.dimensions : []
      // 计算 vsBenchmark，空数组/空基准时兜底为 0
      const equityCurve = Array.isArray(backtestResult.equityCurve) ? backtestResult.equityCurve : []
      const benchmarkCurve = Array.isArray(backtestResult.benchmarkCurve) ? backtestResult.benchmarkCurve : []
      const lastEquity = equityCurve[equityCurve.length - 1]
      const lastBenchmark = benchmarkCurve[benchmarkCurve.length - 1]
      let vsBenchmark = 0
      if (lastEquity && typeof lastEquity.portfolioValue === 'number' && lastBenchmark && typeof lastBenchmark.benchmarkValue === 'number' && lastBenchmark.benchmarkValue !== 0) {
        vsBenchmark = ((lastEquity.portfolioValue - lastBenchmark.benchmarkValue) / lastBenchmark.benchmarkValue) * 100
      }
      let backtest = {
        "startDate": backtestParams.startDate || '',
        "endDate": backtestParams.endDate || '',
        "metrics": backtestMetrics,
        "vsBenchmark": vsBenchmark,//对比对象
        "customerEvaluation": {
          "meetsExpectation": backtestEvaluation.meetsExpectation,
          "failedDimensions": backtestDimensions.filter(d => d && !d.passed).map(dim => dim.name)
        }
      }
      console.log("回测结果backtest>>>>", backtest);
      //stressTest 拼接
      const yaliceshiResult = this.readStorageJSON('yaliceshiResult', {})
      const yaliceshiScenario = yaliceshiResult.scenario || {}
      const yaliceshiMetrics = yaliceshiResult.metrics || {}
      const yaliceshiEvaluation = yaliceshiResult.customerEvaluation || {}
      const yaliceshiDimensions = Array.isArray(yaliceshiEvaluation.dimensions) ? yaliceshiEvaluation.dimensions : []
      let stressTest = {
        "scenarioName": yaliceshiScenario.name || '',
        "metrics": {
          "totalLossPercentage": yaliceshiMetrics.totalLossPercentage,
          "maxDrawdownDuringShock": yaliceshiMetrics.maxDrawdownDuringShock,
          "daysToRecover": yaliceshiMetrics.daysToRecover
        },
        "customerEvaluation": {
          "meetsExpectation": yaliceshiEvaluation.meetsExpectation,
          "failedDimensions": yaliceshiDimensions.filter(d => d && !d.passed).map(dim => dim.name)
        }
      }
      //新增参数 "calculatedRules": 计算规则
      let futureReturns = this.calculateFutureReturns({
        annualizedReturn: backtestMetrics.annualizedReturn ?? 0,//年化收益率
        annualizedVolatility: backtestMetrics.annualizedVolatility ?? 0,//年化波动率
        investmentHorizonYears: backtestProfile.investmentHorizonYears ?? 1,//投资期限
        principal: backtestParams.initialCapital ?? 1000000//初始资金
      })
      console.log("未来收益率futureReturns>>>>", futureReturns);
      // **N年累计收益率 (R)** = `(1 + r)^N - 1` (若 `1+r` 小于 0 则累计收益率强制设为 `-100.00%`)
      // let shouyilv = ''
      // 组合层止盈线 (portfolioTakeProfit)** = `((1 + expectedAnnualReturn / 100)^N - 1) * 1.2`，其中 `N` 为投资期限，`expectedAnnualReturn` 为年化收益率，`1.2` 为止盈比例
      // let portfolioTakeProfit = ((1 + backtestResult.metrics.annualizedReturn / 100, backtestParams.customerProfile.investmentHorizonYears) - 1) * 1.2
      const annualReturn = backtestMetrics.annualizedReturn ?? 0; // 如果没有则默认为0%
      const years = backtestProfile.investmentHorizonYears ?? 1; // 默认1年

      let portfolioTakeProfit = (Math.pow(1 + annualReturn / 100, years) - 1) * 1.2;
      // 如果止盈线为负数（年化亏损时），可以置为0或做特殊处理
      if (portfolioTakeProfit < 0) portfolioTakeProfit = 0;
      console.log("组合层止盈线portfolioTakeProfit>>>>", portfolioTakeProfit);

      //**组合层止损线 (portfolioStopLoss)** = `min(maxDrawdownDuringShock * 0.8, maxAcceptableDrawdown / 100)`
      // let portfolioStopLoss = Math.min(yaliceshiResult.metrics.maxDrawdownDuringShock * 0.8, riskResult.customerProfile.maxAcceptableDrawdown / 100)
      const shockDrawdown = yaliceshiMetrics.maxDrawdownDuringShock ?? 0;
      const maxAcceptable = riskResult.customerProfile.maxAcceptableDrawdown ?? 0;

      // 假设 shockDrawdown 为小数，maxAcceptable 为百分数（常见情况）
      let portfolioStopLoss = Math.min(shockDrawdown * 0.8, maxAcceptable / 100);

      // 如果结果小于 0（极端情况），置为 0 防止负止损
      if (portfolioStopLoss < 0) portfolioStopLoss = 0;
      console.log("组合层止损线portfolioStopLoss>>>>", portfolioStopLoss);

      //**复盘频率 (reviewFrequency)**：`N <= 2` 为 `"双周"` ； `3 <= N <= 7` 为 `"月度"` ； `N >= 8` 为 `"季度"`。
      let reviewFrequency = backtestProfile.investmentHorizonYears ?? 1
      if (reviewFrequency <= 2) {
        reviewFrequency = "双周"
      } else if (3 <= reviewFrequency && reviewFrequency <= 7) {
        reviewFrequency = "月度"
      } else if (reviewFrequency >= 8) {
        reviewFrequency = "季度"
      }
      console.log("复盘频率reviewFrequency>>>>", reviewFrequency);
      //  **再平衡阈值 (rebalanceThreshold) **：`riskType` 为 C1/C2 为 `"±3%"` ； C3 为 `"±5%"` ； C4/C5 为 `"±7%"`
      let rebalanceThreshold = "±5%"
      if (riskResult.type == "C1/C2") {
        rebalanceThreshold = "±3%"
      } else if (riskResult.type == "C3") {
        rebalanceThreshold = "±5%"
      } else if (riskResult.type == "C4/C5") {
        rebalanceThreshold = "±7%"
      }
      console.log("再平衡阈值rebalanceThreshold>>>>", rebalanceThreshold);

      // **年化跌破告警线 (warningLine)** = `(annualizedReturn - 2 * annualizedVolatility)`
      let warningLine = ((backtestMetrics.annualizedReturn ?? 0) - 2 * (backtestMetrics.annualizedVolatility ?? 0)).toFixed(2)
      console.log("年化跌破告警线warningLine>>>>", warningLine);

      let calculatedRules = {
        "futureReturns": futureReturns,//未来回报
        // "portfolioTakeProfit": "100.35%",// 组合层止盈线
        // "portfolioStopLoss": "10.91%",// 组合层止损线
        "portfolioTakeProfit": (portfolioTakeProfit * 100).toFixed(2) + '%',// 组合层止盈线
        "portfolioStopLoss": (portfolioStopLoss * 100).toFixed(2) + '%',// 组合层止损线
        "reviewFrequency": reviewFrequency,//审核频率
        "rebalanceThreshold": rebalanceThreshold,//再平衡阈值
        "warningLine": warningLine// 警戒线
      }
      console.log("计算规则calculatedRules>>>>", calculatedRules);
      let content = {
        "kyc": kyc,
        "model": model,
        "portfolio": portfolio,
        "backtest": backtest,
        "stressTest": stressTest,
        "calculatedRules": calculatedRules
      }
      console.log("投研传递参数》》》content>>>>", content);
      // 存入缓存
      localStorage.setItem('TZBGParams', JSON.stringify(content))
      // setTimeout(() => {
      //   this.loading = false
      //   this.$router.push({ name: 'Touzibaogao' })
      // }, 5000)
      // return
      // 生成一个唯一的chatId
      const chatId = new Date().getTime()
      const requestData = {
        headers: {
          'Authorization': `Bearer ${this.FastGptToken_TZBG}`
        },
        url: this.FastGptApiUrl + '/api/v1/chat/completions',
        method: 'POST',
        data: {
          "stream": false,
          "detail": false,
          "chatId": String(chatId),
          "messages": [
            {
              "content": JSON.stringify(content),
              "role": "user"
            }
          ]
        }
      }
      this.requestTouziBaogao(requestData, 0)
    },
    requestTouziBaogao (requestData, retryCount) {
      this.loading = true
      axios(requestData).then(res => {
        console.log("res>>>", res)
        let text = ''
        if (res?.data && (res.status == 200 || res.status == 304)) {
          const data = res.data
          if (data.code == 514 || data.code == 403) {
            this.$alert('工作流API秘钥不正确，请检查！')
            this.loading = false
            return
          }
          text = data.choices[0].message.content || ''
        } else {
          console.log("res>>else>", res);
          text = res.choices[0].message.content || ''
        }
        if (text.indexOf('</think>') > -1) {
          text = text.split('</think>')[1]
        }
        text = text.trim()
        console.log("text>>>>", text);
        // text 为空则重新调用接口，最多重试 2 次
        if (!text && retryCount < 2) {
          this.requestTouziBaogao(requestData, retryCount + 1)
          return
        }
        localStorage.setItem('TZBG', text)
        this.loading = false
        this.$router.push({ name: 'Touzibaogao' })
      }).catch((err) => {
        console.log("Err>>>", err);
        this.$alert(err.message)
        this.loading = false
      })
    },
  }
}
</script>

<style scoped lang="less">
.yaliceshi-jieguo-page {
  min-height: 100vh;
  // background: linear-gradient(to right, #eff6ff, #f9fbff);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 32px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 32px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.logo i {
  font-size: 32px;
  color: #ef4444;
}

.logo h1 {
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #fc471d;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 16px 0;
}

.status-banner {
  padding: 12px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 600;
}

.status-banner.pass {
  background: #d1fae5;
  color: #10b981;
}

.status-banner.fail {
  background: #fee2e2;
  color: #ef4444;
}

.status-banner i {
  font-size: 18px;
}

.metrics-bar {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.metric-item {
  padding: 16px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 200px;
}

.metric-item.pass {
  border-left: 4px solid #10b981;
}

.metric-item.fail {
  border-left: 4px solid #ef4444;
}

.metric-item i {
  font-size: 20px;
  color: #929394;
}

.metric-label {
  font-size: 14px;
  color: #64748b;
  flex: 1;
}

.metric-value {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.metric-item.fail .metric-value {
  color: #ef4444;
}

.metric-item.pass .metric-value {
  color: #10b981;
}

.content {
  display: flex;
  gap: 32px;
  margin-bottom: 32px;
}

.left-section {
  flex: 1;
}

.right-section {
  flex: 1;
}

.report-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;
}

.report-card.pass {
  border-left: 4px solid #10b981;
}

.report-card.fail {
  border-left: 4px solid #ef4444;
}

.report-title {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.report-title i {
  font-size: 18px;
}

.test-result {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.result-label {
  font-size: 14px;
  color: #64748b;
  margin-right: 8px;
}

.result-value {
  padding: 4px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
}

.result-value.pass {
  background: #d1fae5;
  color: #10b981;
}

.result-value.fail {
  background: #fee2e2;
  color: #ef4444;
}

.test-details {
  margin-bottom: 12px;
}

.test-details /deep/ .el-table td,
.test-details /deep/ .el-table th {
  padding: 4px 6px;
}

.test-details /deep/ .el-table .cell {
  line-height: 1.4;
  font-size: 12px;
}

.detail-item {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
  line-height: 1.4;
}

.detail-item .value {
  color: #1e293b;
  font-weight: 600;
}

.suggestions {
  padding: 16px;
  border-radius: 8px;
}

.suggestions.pass {
  background: #d1fae5;
}

.suggestions.fail {
  background: #fee2e2;
}

.suggestion-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.suggestion-content {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}

.chart-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0 0 20px 0;
}

.chart {
  flex: 1;
  min-height: 300px;
  margin-bottom: 16px;
}

.chart-note {
  font-size: 12px;
  color: #94a3b8;
}

.note-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.note-item .dot {
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
}

.data-source {
  display: block;
  text-align: right;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.footer-bottom {
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #155dfc;
    cursor: pointer;
  }
}

.reset-btn {
  width: 300px;
  font-size: 18px;
  background: #e2e8f0;
  font-size: 18px;
  color: #64748b;
}

.reset-btn:hover {
  background: #cbd5e1;
}

.action-btn {
  width: 300px;
  font-size: 18px;
}

.action-btn.pass {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
}

.action-btn.fail {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  cursor: not-allowed;
  opacity: 0.6;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.scenario-btn {
  padding: 12px 24px;
  background: white;
  border: 2px solid #3b82f6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #3b82f6;
  cursor: pointer;
  transition: all 0.3s ease;
}

.scenario-btn:hover {
  background: #3b82f6;
  color: white;
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .yaliceshi-jieguo-page {
    padding: 20px 40px;
    height: 100%;
    overflow-y: auto;
  }

  .header {
    margin-bottom: 10px;
  }

  .subtitle {
    margin: 0 0 8px 0;
  }

  .metrics-bar {
    margin-bottom: 12px;
  }

  .logo h1 {
    font-size: 32px;
  }

  .logo i {
    font-size: 36px;
  }

  .content {
    gap: 16px;
    margin-bottom: 16px;
  }

  .report-card,
  .chart-card {
    padding: 16px;
  }

  .chart {
    min-height: 300px;
  }

  .reset-btn,
  .action-btn,
  .scenario-btn {
    padding: 14px 28px;
    font-size: 16px;
  }

  .footer {
    gap: 8px;
    margin-top: 16px;
  }

  .footer-bottom {
    margin-top: 8px;

    span {
      font-size: 12px;
    }
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .yaliceshi-jieguo-page {
    padding: 20px 16px;
    min-height: 100vh;
    // background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    // gap: 16px;
  }

  .header {
    margin-bottom: 0;
    text-align: center;
    // padding-top: 10px;
  }

  .logo {
    // flex-direction: column;
    gap: 8px;
    justify-content: center;
  }

  .logo h1 {
    font-size: 18px;
    font-weight: 700;
    // color: #1e293b;
    letter-spacing: 0.5px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-clip: text;
    margin: 0;
  }

  .logo i {
    font-size: 20px;
    // color: #6366f1;
  }

  .subtitle {
    font-size: 13px;
    color: #64748b;
  }

  .content {
    flex-direction: column;
    gap: 16px;
    /* flex: 1; */
    display: flex;
  }

  .metrics-bar {
    flex-direction: column;
    gap: 12px;
  }

  .metric-item {
    width: 100%;
    padding: 16px;
    border-radius: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.06);
  }

  .metric-title {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 6px;
  }

  .metric-value {
    font-size: 22px;
    font-weight: 700;
  }

  .metric-value.pass {
    color: #10b981;
  }

  .metric-value.fail {
    color: #ef4444;
  }

  .metric-label {
    font-size: 12px;
    margin-top: 4px;
  }

  .report-card {
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .report-title {
    font-size: 14px;
    font-weight: 600;
    // color: #334155;
  }

  .result-section {
    padding: 14px;
    border-radius: 10px;
  }

  .result-icon {
    font-size: 24px;
  }

  .result-text {
    font-size: 16px;
    font-weight: 600;
  }

  .suggestions {
    padding: 14px;
    border-radius: 10px;
  }

  .suggestion-title {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
  }

  .suggestion-content {
    font-size: 12px;
    color: #64748b;
  }

  .chart-card {
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .chart-title {
    font-size: 14px;
    font-weight: 600;
    // color: #6366f1;
    margin-bottom: 14px;
  }

  .chart {
    min-height: 200px;
    margin-bottom: 12px;
  }

  .chart-note {
    font-size: 11px;
    color: #94a3b8;
  }

  .footer {
    display: none;
    flex-direction: column;
    gap: 12px;
    margin-top: 0;
    padding-top: 0;
  }

  .reset-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    border: 1px solid #e2e8f0;
    color: #64748b;
    transition: all 0.2s ease;
  }

  .reset-btn:hover {
    background: #cbd5e1;
  }

  .action-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .action-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .action-btn:hover::before {
    left: 100%;
  }

  .action-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }

  .action-btn.fail {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .action-btn.fail:hover {
    transform: none;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
  }

  .scenario-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: white;
    border: 2px solid #6366f1;
    color: #6366f1;
    transition: all 0.2s ease;
  }

  .scenario-btn:hover {
    background: #6366f1;
    color: white;
  }

  .footer-bottom {
    display: none;
    margin-top: 8px;

    span {
      font-size: 12px;
      color: #6366f1;
    }
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .yaliceshi-jieguo-page {
    padding: 16px;
  }

  .header {
    margin-bottom: 16px;
  }

  .logo h1 {
    font-size: 20px;
  }

  .logo i {
    font-size: 24px;
  }

  .subtitle {
    font-size: 12px;
  }

  .status-banner {
    padding: 10px 16px;
    font-size: 12px;
  }

  .report-card,
  .chart-card {
    padding: 16px;
    border-radius: 12px;
  }

  .chart {
    min-height: 250px;
  }

  .reset-btn,
  .action-btn,
  .scenario-btn {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>